import { gql } from '@apollo/client';

export const GET_EXP = gql`
  query GetExp {
    exp @client
  }
`;
